import { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Moderation } from './Moderation';
import { FileText, BarChart3, Menu, Badge, X, LogOut, User, Settings } from 'lucide-react';
import { API_URL } from '../config';
import { AdminStatistic } from './AdminStatistic';
import AdminSettings from './AdminSettings';
import { authFetch } from '../utils/authFetch';
import { useOutletContext } from 'react-router-dom';


export function ModeratorLayout() {
  const { onLogout, moderatorData } = useOutletContext();

  const [activeTab, setActiveTab] = useState('moderation');
  const [documents, setDocuments] = useState([]);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  

  useEffect(() => {
          const fetchDocuments = async () => {
            try {
              const token = localStorage.getItem('token');
              const res = await authFetch(`${API_URL}/documents/all`, {
                method: 'GET',
                headers: {
                  'Authorization': `Bearer ${token}`
                }
              });
              if (!res.ok) {
                throw new Error(`Server responded ${res.status}`);
              }
              const data = await res.json();
              setDocuments(data);
            } catch (err) {
              console.error('Ошибка при получении документов:', err);
            }
          };
          fetchDocuments();
        }, []);

  const handleMenuItemClick = (itemId) => {
    setActiveTab(itemId)
    setIsMobileMenuOpen(false)
  }
  
    const renderContent = () => {
        switch (activeTab) {
          case 'moderation':
            return <Moderation />;
          case 'admin-statistic':
            return <AdminStatistic />;
          case 'admin-settings':
            return <AdminSettings />;
        }
      }

    const pendingDocuments = documents.filter(doc => doc.status === 'pending').length

    const menuItems = [
      { id: 'moderation', label: 'Модерация документов', icon: FileText },
      { id: 'admin-statistic', label: 'Статистика платформы', icon: BarChart3 },
      { id: 'admin-settings', label: 'Настройки платформы', icon: Settings }
    ];

    return (
      <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white border-b border-gray-200 sticky top-0 z-40">
        <div className="px-3 sm:px-4 lg:px-8">
          <div className="flex justify-between items-center h-14 sm:h-16">
            <div className="flex items-center gap-2 sm:gap-4">
              {/* Mobile menu button */}
              <Button
                variant="ghost"
                size="sm"
                className="lg:hidden p-2"
                onClick={() => setIsMobileMenuOpen(true)}
              >
                <Menu className="h-5 w-5" />
              </Button>
              <h1 className="text-lg sm:text-xl font-semibold text-gray-900">Панель модератора</h1>
            </div>
            
            <div className="flex items-center gap-2 sm:gap-4">
              <div className="hidden sm:flex items-center gap-2 text-gray-600">
                <User className="h-4 w-4" />
                <span className="text-sm">{moderatorData?.name || 'Администратор'}</span>
              </div>
              <Button
                variant="outline"
                onClick={onLogout}
                className="text-red-600 border-red-200 hover:bg-red-50 text-xs sm:text-sm p-2 sm:px-3"
              >
                <LogOut className="h-3 w-3 sm:h-4 sm:w-4 sm:mr-2" />
                <span className="hidden sm:inline">Выйти</span>
              </Button>
            </div>
          </div>
        </div>
      </header>

      {/* Mobile menu overlay */}
      {isMobileMenuOpen && (
        <div className="fixed inset-0 z-50 lg:hidden">
          <div className="fixed inset-0 bg-black/20" onClick={() => setIsMobileMenuOpen(false)} />
          <div className="fixed left-0 top-0 h-full w-80 bg-white shadow-xl">
            <div className="p-4 border-b">
              <div className="flex items-center justify-between">
                <h2 className="font-semibold">Меню</h2>
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  <X className="h-5 w-5" />
                </Button>
              </div>
            </div>
            <nav className="p-2">
              {menuItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => handleMenuItemClick(item.id)}
                  className={`
                    w-full flex items-center gap-3 px-3 py-3 rounded-lg text-left transition-colors relative
                    ${activeTab === item.id 
                      ? 'bg-blue-50 text-[#2563eb] border border-blue-200' 
                      : 'text-gray-600 hover:bg-gray-50'
                    }
                  `}
                >
                  <item.icon className="h-5 w-5" />
                  <span className="font-medium">{item.label}</span>
                </button>
              ))}
            </nav>
          </div>
        </div>
      )}

      <div className="flex">
        {/* Desktop Sidebar */}
        <aside className="hidden lg:block w-64 flex-shrink-0 bg-white border-r border-gray-200 min-h-screen">
          <div className="sticky top-20">
            <nav className="p-2">
              {menuItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => setActiveTab(item.id)}
                  className={`
                    w-full flex items-center gap-3 px-3 py-2 rounded-lg text-left transition-colors relative
                    ${activeTab === item.id 
                      ? 'bg-blue-50 text-[#2563eb] border border-blue-200' 
                      : 'text-gray-600 hover:bg-gray-50'
                    }
                  `}
                >
                  <item.icon className="h-5 w-5" />
                  <span className="font-medium">{item.label}</span>
                </button>
              ))}
            </nav>
          </div>
        </aside>

        {/* Main Content */}
        <main className="flex-1 min-w-0">
          <div className="bg-white shadow-sm border-b border-gray-200 lg:border-0 min-h-screen">
            {renderContent()}
          </div>
        </main>
      </div>
    </div>
    );
}
